import React from 'react';
import {CSSProperties} from 'react';

import {utils} from '../utils';
import {theme} from '../constants';

type Props = {
  style?: CSSProperties;
  numberOfLines?: number;
  children: React.ReactNode;
};

const H1: React.FC<Props> = ({
  style,
  children,
  numberOfLines = 0,
}): JSX.Element => {
  return (
    <h1
      style={{
        fontSize: 32,
        lineHeight: 1.3,
        textTransform: 'capitalize',
        color: theme.colors.mainColor,
        ...theme.fonts.Inter_700Bold,
        ...style,
        ...(numberOfLines
          ? (utils.numberOfLines(numberOfLines) as CSSProperties)
          : {}),
      }}
    >
      {children}
    </h1>
  );
};

export default H1;
